import { DoDont } from '@af/design-system-docs-ui/do-dont';
import { DoDontGrid } from '@af/design-system-docs-ui/do-dont-grid';
import iconDark from "../../../../src/pages/rovo-ui/icon/_assets/icon-dark.png";
import iconLight from "../../../../src/pages/rovo-ui/icon/_assets/icon-light.png";
import iconTileDark from "../../../../src/pages/rovo-ui/icon/_assets/icon-tile-dark.png";
import iconTileLight from "../../../../src/pages/rovo-ui/icon/_assets/icon-tile-light.png";
import pairIconDark from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-dark.png";
import pairIconDoDark from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-do-dark.png";
import pairIconDoLight from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-do-light.png";
import pairIconDontDark from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-dont-dark.png";
import pairIconDontLight from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-dont-light.png";
import pairIconLight from "../../../../src/pages/rovo-ui/icon/_assets/pair-icon-light.png";
import * as React from 'react';
export default {
  DoDont,
  DoDontGrid,
  iconDark,
  iconLight,
  iconTileDark,
  iconTileLight,
  pairIconDark,
  pairIconDoDark,
  pairIconDoLight,
  pairIconDontDark,
  pairIconDontLight,
  pairIconLight,
  React
};